<template>
    <Line ref="chart" :data="chartData" :options="chartOptions" @dblclick="handleDoubleClick"/>
  </template>
  
  <script>
  import { Line } from 'vue-chartjs';
  import { Chart, registerables } from 'chart.js';
  import zoomPlugin from 'chartjs-plugin-zoom';
  import 'chartjs-adapter-date-fns';
  
  Chart.register(...registerables, zoomPlugin);
  
  export default {
    name: 'TemperatureChart',
    components: { Line },
    props: {
        cycleIDs: Array,
      labels: Array,
      datasets: Array,
    },
    computed: {
      chartData() {
        return {
          labels: this.labels,
          datasets: this.datasets,
        };
      },
      chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2,
          layout: { padding: 10 },
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'hour',
                tooltipFormat: 'yyyy-MM-dd HH:mm:ss',
              },
            },
            y: {
              beginAtZero: true,
              min: Math.min(...this.datasets.flatMap((d) => d.data)) - 5,
              max: Math.max(...this.datasets.flatMap((d) => d.data)) + 5,
              ticks: { stepSize: 5 },
            },
          },
          plugins: {
            legend: { display: true, position: 'bottom' },
            zoom: {
              zoom: { wheel: { enabled: true, modifierKey: 'shift' }, pinch: { enabled: true }, mode: 'xy'},
              pan: { enabled: true, mode: 'xy', modifierKey: 'ctrl' },
            },
          },
        };
      },
    },
    methods: {
        handleDoubleClick(event) {
        const chart = this.$refs.chart.chart;
      if (chart) {
        const activePoints = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
        if (activePoints.length > 0) {
          const clickedIndex = activePoints[0].index;
          const cycleId = this.cycleIDs[clickedIndex]; // Access parent data
          this.$emit('cycle-selected', cycleId); // Emit the selected cycle ID
        }
      }
    },
  },
  };
  </script>